/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForSaasCostProcessing extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForSaasCostProcessing");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForSaasCostProcessing.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForSaasCostProcessing>): BackgroundJobPayloadForSaasCostProcessing {
        let obj = Object.assign(new BackgroundJobPayloadForSaasCostProcessing(), model);
        BackgroundJobPayloadForSaasCostProcessing.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForSaasCostProcessing>): BackgroundJobPayloadForSaasCostProcessing {
        if (!model) return null;
        return BackgroundJobPayloadForSaasCostProcessing.newInstance(<BackgroundJobPayloadForSaasCostProcessing> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForSaasCostProcessing) {
        if (!obj) return;

        models.BackgroundJobPayloadForSaasCostProcessing.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForSaasCostProcessing): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForSaasCostProcessing.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.backfill_start_date === "string") {
            this.backfill_start_date = new Date(<string><any>this.backfill_start_date);
        }
        if (typeof this.backfill_end_date === "string") {
            this.backfill_end_date = new Date(<string><any>this.backfill_end_date);
        }
        if (this.progress) {
            models.CostProcessingProgress.fixupPrototype(this.progress);
        }
    }

    /**
     * Target SaaS Account
     */
    service_account_id: string;

    backfill_start_date: Date;

    backfill_end_date: Date;

    /**
     * Progress of the cost processing
     */
    progress: models.CostProcessingProgress;

}
